/**
 * @license
 * Copyright© Celligence International, LLC - 2023
 * This software program is protected by copyright laws and is the property of
 * Celligence International, LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 */
import React, { useCallback, useEffect, useState, useRef } from "react";
import { Container, Row, Button, Col } from "react-bootstrap";
import "./Contactus.css";
import { BorrowerLeadGenerationTool } from "borrower-lead-generation-tool";
import axios from "axios";
import MediaQuery from "react-responsive";
import content from '../content.json';
import parse from 'html-react-parser';
import { useParams } from 'react-router-dom';

export default function Contactus({ links, loanPurpKeyword,
  noteRate,
  formHeading,
  showLeadFormModal,
  onHide,
  offerTerm, dataJson, realtorData, loanOfficerData }) {
  const [showFormModal, setShowFormModal] = useState(false);
  const [loanPurposeKwd, setLoanPurposeKwd] = useState("");
  const [frmHeading, setFrmHeading] = useState("");
  const ref = useRef();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [isIntersecting, setIntersecting] = useState(false);
  const [footerInfoData, setFooterInfoData] = useState();
  const [loInfo, setLoInfo] = useState(null); // Initialize loInfo as null
  const [loanOfficerUid, setLoanOfficerUid] = useState('');
  const { loName } = useParams();
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {

    const fetchSWMCFooterInfo = async () => {
      try {
        await axios
          .get(process.env.REACT_APP_SWMC_FOOTET_INFO)
          .then((response) => {
            //console.log(response.data);
            setFooterInfoData(response.data);
            const observer = new IntersectionObserver(([entry]) => {
              if (entry.isIntersecting) {
                setIntersecting(entry.isIntersecting);
                observer.disconnect();
              }
            });
            observer.observe(ref.current);
            // Remove the observer as soon as the component is unmounted
            return () => {
              observer.disconnect();
            };
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    };

    fetchSWMCFooterInfo();
  }, []);

  useEffect(() => {
    // Fetch LO details JSON from a JSON endpoint
    const fetchLoInfo = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_LO_DETAILS_CASHOUTREFI_JSON}`); // Replace with your JSON endpoint URL
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const data = await response.json();
        // Find the LO details by matching the URL parameter
        const matchingLoInfo = data.find(lo => lo.url === loName);
        if (matchingLoInfo) {
          setLoInfo(matchingLoInfo); // Set the LO info
          setLoanOfficerUid(matchingLoInfo.loanofficerUid); // Set the loanOfficerUid
        } else {
          // Handle the case where no matching LO Name is found
          // You can set an error state or handle it as needed
        }
      } catch (error) {
        console.error('Error fetching LO info:', error);
        // Handle the error, e.g., set an error state
      }
    };

    fetchLoInfo(); // Call the fetch function when the component mounts
  }, [loName]); // Fetch whenever loName changes

  const handleApplyNowModal = () => {
    setShowFormModal(true);
    setLoanPurposeKwd("");
    setFrmHeading("Apply Now");
  };
  const [node, setNode] = useState(null);
  const formRef = useCallback((node) => {
    // node refers to the name input field in the BorrowerLeadGenerationTool
    setNode(node);
  }, []);
  const handleCloseFormModal = () => setShowFormModal(false);

  const imgCDNURL = process.env.REACT_APP_VASTREAMLINE_PROGRAM_CDN_URL;
  const realtorLoId = loanOfficerData ? loanOfficerData.ssid : "";

  // const { loName } = useParams();
  // const loInfo = loData.find(lo => lo.url === loName);
  function removeNonAsciiSpecialCharacters(str) {
    //check if pass value is null or blank.
    //return empty string if pass value is null or blank
    if (str === null || str === "") {
      return "";
    } else {
      //convert the pass value to string
      str = str.toString();
      //remove non-printable ASCII chars and replace it with empty string
      str = str.replace(/[^\x20-\x7E]/g, "");
      //replace all special characters with empty string
      str = str.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}0-9\[\]\\\/]/g, "");
      //return updated string to calling function
      return str;
    }
  }

  const handleFirstName = (evt) => {
    let tempFirstName = evt.currentTarget.value;
    tempFirstName = removeNonAsciiSpecialCharacters(tempFirstName);
    
    if (tempFirstName) {
      if (tempFirstName.includes(" ")) {
        // If both first and last names are entered together
        const names = tempFirstName.split(" ");
        let fName = names[0];
        let lName = names.slice(1).join(" ");
        setFirstName(fName.trim());
        setLastName(lName.trim());
      } else {
        // If only the first name is entered
        setFirstName(tempFirstName.trim());
      }
    } else {
      setFirstName("");
    }
  };
  
  
  useEffect(() => {
    if (node) {
    
      const messageInput = document.getElementById("message");

      messageInput.placeholder = "Your Message";
      messageInput.ariaPlaceholder = "Your Message";

      
    }
  }, [node]);   

  return (
    <>

      <Container>
        <Row className="borrtoolrow mb-3">
          <Col className="borrleadtoolcol" xs={12} sm={12} md={12} xl={12} xxl={12} lg={12}>
            <div className="request">
              <p>Connect With Me</p>
            </div>
            <BorrowerLeadGenerationTool
              leadSource="Self"
              branch=""
              loanPurposeKeyword="STREAMLINE REFI"
              showModalBackBtn={false}
              offerLoanTypeKeyword="FHA/TITLE II"
              offerLoanProductCode="SO11S01F00"
              // statesDomain={process.env.REACT_APP_STATE_DOMAIN}
              ref={formRef}
              loanOfficerUid={realtorLoId}
              mainBtnName="Tell Me More"
              mainBtnNameTru="Learn More About TRU Approval"
              
            />
          </Col>
          <Col sm={12} md={12} xl={1} xxl={1} lg={1}></Col>
        </Row>
      </Container>
    </>
  );
}
